import { DatePicker, Form } from "antd";
import moment from "moment";
import { useEffect } from "react";
import CellDatePicker from "../../../simple/CellDatePicker";
import FormWrapper from "../../FormWrapper";

import './ScheduleCancellationForm.scss';

const ScheduleCancellationForm = (props) => {
  const {
    form,
    values,
    setValues,
    classReducer,
    groupsReducer,
    onClose,
    groupId,
    scheduleCancellation,
  } = props;

  const { classesOrigin } = classReducer;

  const onChange = (formValue) => {
    setValues({
      ...values,
      ...formValue,
    });
  };

  const onFinish = () => {
    let endDate = moment(values.end_date).format('YYYY-MM-DD');
    const payload = {
      ...values,
      start_date: moment(values.start_date).format('YYYY-MM-DD'),
      end_date: endDate
    };

    scheduleCancellation(groupId, payload);
  };

  useEffect(() => {
    if (groupsReducer.loading.SCHEDULE_CANCELLATION?.state === 'success') {
      window.location.href = `/classes`;
    }
  }, [groupsReducer.loading.SCHEDULE_CANCELLATION]);
  
  return (
    <div className="schedule-cancellation-form">
      <h1>Anular clases programadas</h1>
      <div>
        <FormWrapper
          {...props}
          name="schedule-cancellation"
          form={form}
          initialValues={values}
          onValuesChange={onChange}
          onFinish={onFinish}
          loading={groupsReducer.loading.SCHEDULE_CANCELLATION?.state}
          cancelButtonText="Regresar"
          saveButtonText="Continuar"
          onRedirectCancelButton={() => onClose()}
        >
          <div className="container-form">
            <Form.Item
              label="A partir de"
              name="start_date"
              rules={[{ required: true }]}
            >
              <DatePicker
                className="date-picker"
                format="DD/MM/YYYY"
                placeholder="dd/mm/aaaa"
                dateRender={(date) => CellDatePicker(date, classesOrigin)}
              />
            </Form.Item>
            <Form.Item
              label="Hasta"
              name="end_date"
            >
              <DatePicker
                className="date-picker"
                format="DD/MM/YYYY"
                placeholder="dd/mm/aaaa"
                dateRender={(date) => CellDatePicker(date, classesOrigin)}
              />
            </Form.Item>
          </div>
        </FormWrapper>
      </div>
    </div>
  );
};

export default ScheduleCancellationForm;
